import { NRKlogo } from '../../shared/index.css'

export const getLogo = () => {
  return `<a class="${NRKlogo}" style="transform: translate3d(0,0,0)" href="http://www.nrk.no/" title="Forsiden av NRK.no">
    <svg width="48.75px" height="18px" viewBox="0 0 152 55" style="position: relative">
      <g stroke="none" stroke-width="0" fill="none">
        <g fill="#f6f6f6" transform="translate(-50.000000, -50.000000)">
          <g transform="translate(50.000000, 50.000000)">
          <path d="M0.06,1.787 L18.646,1.787 L18.646,54.94 L0.06,54.94 L0.06,1.787 Z" data-reactid=".0.2.0.0.0.0.0"></path>
          <path d="M53.194,1.787 L71.847,1.787 L71.847,54.94 L53.194,54.94 L53.194,1.787 Z"></path>
          <path d="M95.233,1.787 L113.887,1.787 L113.887,54.94 L95.233,54.94 L95.233,1.787 Z" ></path>
          <path d="M83.54,0.681 C77.723,0.681 73.017,5.431 73.017,11.289 C73.017,17.142 77.723,21.896 83.54,21.896 C89.352,21.896 94.071,17.142 94.071,11.289 C94.071,5.431 89.352,0.681 83.54,0.681"></path>
          <path d="M137.206,30.871 C136.096,28.972 136.036,27.807 137.11,25.985 L151.893,1.787 L131.391,1.787 C131.391,1.787 119.059,21.915 117.383,24.718 C115.708,27.511 115.774,29.255 117.452,32.125 C119.129,34.996 131.391,55 131.391,55 L151.893,55 C151.893,55 137.379,31.164 137.206,30.871"></path>
          <path d="M42.041,10.319 C41.09,5.456 36.822,1.787 31.709,1.787 L19.731,1.787 L31.756,55 L52.047,55 L42.041,10.319"></path>
          </g>
        </g>
      </g>
    </svg>
  </a>`
}


// WEBPACK FOOTER //
// ./src/client/utils/getLogo.js